import { useState, useEffect } from 'react';
// import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router';
// import { uploadImage } from '../../../Config/azure-storage-blob.ts';
import { ServerPath } from '../../../Constant/index.jsx';
import {uploadImage} from '../../../Services/r2-storage-blob.js';
import { _axios } from '../../../utils/axios.jsx';



const FormPost = () => {
  const navigate = useNavigate();

  const data = [
    { name: 'Lifestyle' },
    { name: 'Travel' }
  ];

  const [title, setTitle] = useState('');
  const [postType, setPostType] = useState('Text');
  const [categories, setCategories] = useState([]);
  const [shortDescription, setShortDescription] = useState('');
  const [longDescription, setLongDescription] = useState('');
  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState('');
  const [uploading, setUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [today, setToday] = useState('');
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setToday(formattedDate);
  }, []);

  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
    setImageName(e.target.files[0].name);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setUploading(true);
    try {
      const uploadedUrl = await uploadImage(image, imageName, 'parikrama-qa', 'images');
      setImageUrl(uploadedUrl);

      const newPost = {
        tenant_id: 'nagpur_001',
        title: title,
        blog_date: today,
        content: shortDescription,
        description: longDescription,
        image: uploadedUrl,
        user_name: "Admin",
      };

      console.log('Payload:', newPost);

      const response = await _axios.post(`${ServerPath}/blog/create`, newPost);
      console.log(response.data);

      navigate(`${process.env.PUBLIC_URL}/blogs`);

    } catch (error) {
      console.error(error.response.data);
    } finally {
      setUploading(false);
    }
  };


  const handleDiscard = () => {
    navigate(`${process.env.PUBLIC_URL}/blogs`);
  };

  return (
    <Form className="row needs-validation" onSubmit={handleSubmit}>
      <Col sm="12">
        <Row className='mb-3'>
          <Form.Group>
            <Form.Label htmlFor="validationCustom01">Title:</Form.Label>
            <Form.Control
              id="validationCustom01"
              type="text"
              placeholder="Post Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
            <div className="valid-feedback">Looks good!</div>
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="image-upload">Upload Image:</Form.Label>
            <Form.Control
              id="image-upload"
              type="file"
              onChange={handleFileChange}
              accept="image/*"
              required={postType === 'Image'}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Short Description:</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={shortDescription}
              onChange={(e) => setShortDescription(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Long Description:</Form.Label>
            <Form.Control
              as="textarea"
              rows={10}
              value={longDescription}
              onChange={(e) => setLongDescription(e.target.value)}
              required
            />
          </Form.Group>
        </Row>
        <Row>
          <div className="btn-showcase">
            <Button type="submit" color="primary" disabled={uploading}>
              {uploading ? 'Uploading...' : 'Post'}
            </Button>
            <Button type="reset" color="light" onClick={handleDiscard}>
              Discard
            </Button>
          </div>
        </Row>
      </Col>
    </Form>
  );
};

export default FormPost;
